<script lang="ts">
import type { ThemeSlots } from '#layers/ui/types/tv';
import { tv } from 'tailwind-variants';

const messageScreenClasses = tv({
	slots: {
		root: 'flex h-full flex-col items-center justify-center px-4',
		body: 'max-w-100 space-y-3.5 text-center text-sm',
		title: 'mt-4 font-medium text-default',
		description: 'text-muted',
		actions: 'mt-6 flex max-w-120 flex-col items-center',
	},
});
</script>

<script lang="ts" setup>
import { computed } from 'vue';

const { title = null, description = null } = defineProps<{
	title?: string | null;
	description?: string | null;
	ui?: ThemeSlots<typeof messageScreenClasses>;
}>();

const theme = computed(() => messageScreenClasses());
</script>

<template>
	<div :class="theme.root({ class: ui?.root })">
		<slot name="illustration" />

		<div
			v-if="title || description || $slots.default"
			:class="theme.body({ class: ui?.body })"
		>
			<h1
				v-if="title"
				:class="theme.title({ class: ui?.title })"
			>
				{{ title }}
			</h1>
			<p
				v-if="description || $slots.description"
				:class="theme.description({ class: ui?.description })"
			>
				<slot name="description">
					{{ description }}
				</slot>
			</p>

			<slot />
		</div>

		<div
			v-if="$slots.actions"
			:class="theme.actions({ class: ui?.actions })"
		>
			<slot name="actions" />
		</div>
	</div>
</template>
